import {MessageRecord} from '@app/services/data.service';

export type ExecFunc = (record: MessageRecord) => void;

export class LazyExec {
  constructor(private func: ExecFunc, private record: MessageRecord) {}
  public apply(): void {
    this.func(this.record);
  }
  public isObsolete(snapshotTimestamp: number): boolean {
    return this.record.timestamp <= snapshotTimestamp;
  }
}

export class ExecBuffer {
  private locked = false;
  private running = false;
  private readonly queue: LazyExec[];

  constructor(locked?: boolean) {
    this.queue = [];
    if (locked) {
      this.locked = locked;
    }
  }

  public lock(): void {
    this.locked = true;
  }

  public unlock(): void {
    this.locked = false;
    if (!this.running) {
      this.execQueue();
    }
  }

  public addToQueue(lazyExec: LazyExec): void {
    this.queue.push(lazyExec);
    if (!this.running) {
      this.execQueue();
    }
  }

  public normalizeAndExecQueue(snapshotTimestamp: number): void {
    while (this.queue.length > 0 && this.queue[0].isObsolete(snapshotTimestamp)) {
      this.queue.shift();
    }
    this.unlock();
  }

  private execQueue(): void {
    this.running = true;
    while (!this.locked && this.queue.length > 0) {
      try {
        this.queue.shift().apply();
      } catch (e) {
        console.error('ExecBuffer error:', e);
      }
    }
    this.running = false;
  }
}
